import { TemplatePortal } from '@angular/cdk/portal';
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToolbarPortalService {
  /**
   * Holds the active portal (if any) provided by the current route component.
   */
  readonly activePortal = signal<TemplatePortal | null>(null);

  setPortal(portal: TemplatePortal | null): void {
    this.activePortal.set(portal);
  }

  clearPortal(): void {
    this.activePortal.set(null);
  }
}
